import { Component, inject } from '@angular/core';
import { PatientRegistrationDetailsComponent } from '../patient-registration-details/patient-registration-details.component';
import { HttpClient } from '@angular/common/http';
import { Patient, Practitioner } from 'fhir/r4';
import { authBackendEndPointToken } from '../app.config';
import { AuthService } from '../shared/auth/auth.service';
import { MatDialog } from '@angular/material/dialog';
import { PatientRegistrationEditComponent } from '../patient-registration-edit/patient-registration-edit.component';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SuccessMessageComponent } from '../shared/success-message/success-message.component';
import { ErrorService } from '../shared/error.service';
import { json } from 'express';

@Component({
  selector: 'app-profile',
  imports: [PatientRegistrationDetailsComponent],
  templateUrl: './profile.component.html',
  styleUrl: './profile.component.scss'
})
export class ProfileComponent {
  profileData?: any;

  http = inject(HttpClient);
  auth = inject(AuthService);
  backendApiBaseUrl = inject(authBackendEndPointToken)
  private dialog = inject(MatDialog);
  private snackBar = inject(MatSnackBar);
  private errorService = inject(ErrorService);
  ngOnInit() {
    this.auth.user.subscribe(user => {
      // CONSOLE.LOG(USSER)
      console.log(user);
      if (!user?.fhirResourceId) {
        return;
      }

      const resourceType = user.role?.toLowerCase() === 'patient' ? 'Patient' : 'Practitioner';
      const cacheBuster = Date.now();

      this.http.get<Patient>(`${this.backendApiBaseUrl}/fhir/${resourceType}/${user.fhirResourceId}?_=${cacheBuster}`).subscribe({
        next: (allData) => {
          this.profileData = allData;
          console.log(allData);
        },
        error: () => {
          this.errorService.openandCloseError('Failed to load profile');
        }
      });
    })

  }

  onEditRequested(resource: Patient | Practitioner) {
    const ref = this.dialog.open(PatientRegistrationEditComponent, {
      data: { resource, context: 'profile', isEditModeForPractitioner: resource.resourceType === 'Practitioner' },
      width: '720px',
      maxWidth: '92vw',
      maxHeight: '93vh'
    });

    ref.afterClosed().subscribe(result => {
      console.log('Dialog closed with result:', result);
      if (result?.updated) {
        const toSave: Patient | Practitioner = result.resource ?? resource;
        if (!toSave.id || !toSave.resourceType) {
          this.errorService.openandCloseError('Updated resource is missing identifiers');
          return;
        }

        this.http.put<Patient | Practitioner>(`${this.backendApiBaseUrl}/fhir/${toSave.resourceType}/${toSave.id}`, toSave, {
          headers: { 'Content-Type': 'application/fhir+json' }
        }).subscribe({
          next: (saved) => {
            this.profileData = saved;
            this.snackBar.openFromComponent(SuccessMessageComponent, {
              data: { message: 'Profile updated successfully.', action: 'Close' },
              duration: 3000,
              horizontalPosition: 'center',
              verticalPosition: 'top'
            });
          },
          error: () => {
            this.errorService.openandCloseError('Failed to update profile');
          }
        });
      }
    });
  }
}
